// enum tên nguồn BCQT 03
export default {
  Domestic: 1,
  Aid: 2,
  ForeignDebt: 3,
  FeeLeave: 4,
  OtherLeave: 5,
};
